import uploadsservicesdomesticViolenceimageshutterstock_2040549059500x281Jpg from "$lib/data/generated/uploads/services/Domestic Violence/image/shutterstock_2040549059 500x281.jpg";

export const uploads = {
  "uploads/services/Domestic Violence/image/shutterstock_2040549059 500x281.jpg": uploadsservicesdomesticViolenceimageshutterstock_2040549059500x281Jpg
};